
import req from './request'

const DEFAULT_ENDPOINTS = {
    detext: '/speech/detect'
}

export default {
    detext(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.detext, param,'bots')
    },
    
}